import React from 'react';

import { genders3, experiences, gradeArr } from '../../../../helper';
import { useProgramForm } from '../../../../context/ProgramFormContext';
import SectionCard from '../ui/SectionCard';
import Field from '../ui/Field';
import { SelectInput, NumberInput } from '../ui/Inputs';

/**
 * Section 2 — Applicable Groups. Ports `AddProgramModal.js:1751-1818`.
 */
const Groups = () => {
    const {
        userInput,
        handleSelect,
        handleMultiSelect,
        handleNumberChange,
        fieldStatus,
    } = useProgramForm();

    return (
        <SectionCard
            id="groups"
            step={2}
            title="Applicable Groups"
            description="Eligibility rules used to filter registrations"
        >
            {/* Grade leads and takes two thirds of the row: it is the only multi-select here,
                and with several grades picked the chips need the width to stay readable.
                Experience Level is a single value and gives it up. Gender moves down to sit
                with the age range. */}
            <div className="row">
                <Field
                    className="col-md-8 mb-3"
                    label="Grade"
                    htmlFor="grade"
                    required
                    {...fieldStatus('grade')}
                >
                    <SelectInput
                        id="grade"
                        isMulti
                        closeMenuOnSelect={false}
                        pHolder="Select Grade"
                        change={e => handleMultiSelect(e, 'grade')}
                        error={fieldStatus('grade').error}
                        value={userInput.grade ? userInput.grade.map(item => ({ value: item, label: item })) : []}
                        options={gradeArr.map(item => ({ value: item, label: item }))}
                    />
                </Field>

                <Field
                    className="col-md-4 mb-3"
                    label="Experience Level"
                    htmlFor="expLevel"
                    required
                    {...fieldStatus('expLevel')}
                >
                    <SelectInput
                        id="expLevel"
                        pHolder="Experience Level"
                        change={e => handleSelect(e, 'expLevel')}
                        error={fieldStatus('expLevel').error}
                        value={userInput.expLevel === '' ? '' : experiences.filter(el => el.value === userInput.expLevel)}
                        options={experiences}
                    />
                </Field>

                <Field
                    className="col-md-4 mb-3"
                    label="Gender"
                    htmlFor="gender"
                    required
                    {...fieldStatus('gender')}
                >
                    <SelectInput
                        id="gender"
                        pHolder="Select a gender"
                        change={e => handleSelect(e, 'gender')}
                        error={fieldStatus('gender').error}
                        value={userInput.gender === '' ? '' : genders3.filter(el => el.value === userInput.gender)}
                        options={genders3}
                    />
                </Field>

                <Field
                    className="col-md-4 mb-3"
                    label="Age Group (Min)"
                    htmlFor="minAge"
                    required
                    {...fieldStatus('minAge')}
                >
                    <NumberInput
                        id="minAge"
                        change={e => handleNumberChange(e, 'minAge')}
                        value={userInput.minAge}
                        pHolder="Min age"
                        min={0}
                        max={99}
                        precision={0}
                        step={1}
                        error={fieldStatus('minAge').error}
                    />
                </Field>

                <Field
                    className="col-md-4 mb-3"
                    label="Age Group (Max)"
                    htmlFor="maxAge"
                    required
                    hint={userInput.minAge === '' ? 'Set the minimum age first.' : ''}
                    {...fieldStatus('maxAge')}
                >
                    <NumberInput
                        id="maxAge"
                        change={e => handleNumberChange(e, 'maxAge')}
                        value={userInput.maxAge}
                        pHolder="Max age"
                        max={100}
                        precision={0}
                        step={1}
                        disabled={userInput.minAge === ''}
                        min={userInput.minAge + 1}
                        error={fieldStatus('maxAge').error}
                    />
                </Field>
            </div>
        </SectionCard>
    );
};

export default Groups;
